/**
 * 敏感词过滤【前端预校验 JSON词库版本】
 * 词库来源：https://github.com/Konsheng/Sensitive-lexicon
 * License: MIT
 * 用途：昵称、签名、小组名称、游记、足迹描述输入前置校验
 * 注意：前端仅作为体验优化，后端腾讯云TMS必须保留兜底审核！
 */
import wordJson from '../assets/wordlist.json'
let SENSITIVE_WORDS = [];
let reg = null;

// 初始化加载词库
function initWordList() {
  if(wordJson && Array.isArray(wordJson.words)){
    SENSITIVE_WORDS = wordJson.words;
  }
  buildRegex();
  console.log("敏感词库加载完成，词数量：", SENSITIVE_WORDS.length);
}

// 构建正则，自动转义特殊字符
function buildRegex() {
  if (!Array.isArray(SENSITIVE_WORDS) || SENSITIVE_WORDS.length === 0) {
    reg = null;
    return;
  }
  const escapeWords = SENSITIVE_WORDS.map(word => {
    return word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  });
  reg = new RegExp(`(${escapeWords.join("|")})`, "i");
}

/**
 * 文本清洗：剔除中文、英文、数字以外所有符号、空格，用于敏感词检测
 */
export function cleanText(text) {
  if (!text) return "";
  return text.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, "");
}

export function hasSensitiveWord(text) {
  if (!reg || !text) return false;
  const pureText = cleanText(text);
  return reg.test(pureText);
}

export function filterSensitiveWord(text) {
  if (!reg || !text) return text;
  return text.replace(reg, "***");
}

/**
 * 综合表单校验【推荐所有输入框统一调用】
 * @param {string} text 用户输入内容
 * @param {number} maxLen 最大允许字符长度
 * @returns {Object} {pass:boolean, msg:string}
 */
export function validateTextContent(text, maxLen = 100) {
  const str = (text || "").trim();
  if (str === "") {
    return { pass: false, msg: "内容不能为空" };
  }
  if (str.length > maxLen) {
    return { pass: false, msg: `内容不能超过${maxLen}个字符` };
  }
  if (hasSensitiveWord(str)) {
    return { pass: false, msg: "内容包含违规词汇，请修改后重试" };
  }
  return { pass: true, msg: "校验通过" };
}

// 初始化
initWordList();